var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('XLMTxContainer',{attrs:{"tx":_vm.tx}},[_c('div',{staticClass:"bump_sequence"},[_c('div',{staticClass:"tx_detail_label"},[_vm._v(" Bumped To ")]),_c('div',{staticClass:"bumped_to"},[_vm._v(" "+_vm._s(_vm.bumped_to)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }